import gsap from 'gsap';
import { trapFocus } from './focus-trap';

export const SelectState = {
    init() {
        $('.slide-panel').hide();
        var stateSelected;
        $('.select-state').on('click', function (e) {
            e.preventDefault();
            $('.slide-panel-city-image').attr('src', '');
            var dataArray = JSON.parse($(this).attr('data-cities'));
            var metroArray = JSON.parse($(this).attr('data-metro-areas'));
            var neighborhoodArray = JSON.parse($(this).attr('data-neighborhoods'));
            var count = $(this).attr('data-count');
            var metroCount = $(this).attr('data-metro-count');
            var neighborhoodCount = $(this).attr('data-neighborhood-count');
            var state = $(this).attr('data-state');
            var imagealt = $(this).attr('data-imagealt');
            var imageurl = $(this).attr('data-imageurl');
            stateSelected = $(this);
            $('.slide-panel-city-image').attr('src', imageurl);
            $('.slide-panel-city-image').attr('alt', imagealt);
            $('.slide-panel-city-name').html(state);
            $('.slide-panel-city-count').html('(' + count + ')');
            var _html = '';
            // Loop through the array using jQuery
            $.each(dataArray, function (index, value) {
                _html +=
                    "<li><a href='" +
                    value.city_link +
                    "'>" +
                    value.city_name +
                    '</a>';
            });
            $('.city-listing-ui').html(_html);

            _html = '';
            // Loop through the array using jQuery
            $.each(metroArray, function (index, value) {
                _html +=
                    "<li><a href='" +
                    value.metro_link +
                    "'>" +
                    value.metro_name +
                    '</a>';
            });
            if(metroCount > 0){
                $('.metro-listing-ui').html(_html);
                $('.metro-listing-div').show()
            } else{
                $('.metro-listing-div').hide();
                $('.metro-listing-ui').html("");
            }

            _html = '';
            // Loop through the array using jQuery
            $.each(neighborhoodArray, function (index, value) {
                _html +=
                    "<li><a href='" +
                    value.neighborhood_link +
                    "'>" +
                    value.neighborhood_name +
                    '</a>';
            });
            if(neighborhoodCount > 0){
                $('.neighborhood-listing-ui').html(_html);
                $('.neighborhood-listing-div').show();
            } else{
                $('.neighborhood-listing-div').hide();
                $('.neighborhood-listing-ui').html("");
            }
            $('.slide-panel').show();
            $('.slide-panel').addClass('open');
            const slidePanel = document.getElementsByClassName('slide-panel');
            setTimeout(function() {
                trapFocus(slidePanel[0]);
              }, 1000);
            $('.back-to-states').focus();

            const slidePanelHeight = $('.slide-panel.open').outerHeight();
            const parentData = $('.slide-panel')
                .parents('.state-thumbnail')
                .find('.state-thumbnail-component');

            if ($(window).width() < 768) {
                setTimeout(() => {
                    gsap.to(parentData, {
                        height: slidePanelHeight - 57,
                        duration: 0.3,
                        delay: 0,
                    });
                    $(parentData).css('overflow', 'hidden');
                }, 1500);
            } else {
                gsap.to(parentData, {
                    height: slidePanelHeight - 57,
                    duration: 0.3,
                    delay: 0,
                });
                $(parentData).css('overflow', 'hidden');
            }
        });

        $('.back-to-states').on('click', function (e) {
            e.preventDefault();
            $('.slide-panel').removeClass('open');
            $('.slide-panel')
                .parents('.state-thumbnail')
                .find('.state-thumbnail-component')
                .height('auto');
                stateSelected.focus();
            $('.slide-panel')
                .parents('.state-thumbnail')
                .find('.state-thumbnail-component')
                .css('overflow', 'unset');            
        });

        const scrollDownToGrid = () => {
            $('.state-thumbnail-container a').click(function (e) {
                $('html, body').animate(
                    {
                        scrollTop:
                            $('.flex-content--state_listing h2').offset().top -
                            10,
                    },
                    2000
                );
            });
        };
        scrollDownToGrid();
    },
};
